<template>
  <div class="asc-doc-mgmt-template">
    <asc-doc-mgmt-wrapper
      :tabs="tabs"
      :user="user"
      :help-about-grid-data="helpAboutGridData"
      :help-about-contents="helpAboutContents"
      :deselect-all-user-guides="deselectAllUserGuides"
      :help-about-grid-disabled="helpAboutGridDisabled"
      v-on="$listeners"
    ></asc-doc-mgmt-wrapper>
  </div>
</template>

<script>
import AscDocMgmtWrapper from '@/components/organisms/AscDocMgmtWrapper'

export default {
  name: 'AscDocMgmtTemplate',

  components: {
    AscDocMgmtWrapper,
  },

  props: {
    tabs: {
      type: Array,
      required: true,
    },
    user: {
      type: Object,
      default: () => {},
    },
    // help & About
    helpAboutGridData: {
      type: Array,
      required: true,
      default: () => [],
    },
    helpAboutGridDisabled: {
      type: Boolean,
      default: false,
    },
    helpAboutContents: {
      type: Array,
      default: () => [],
    },
    deselectAllUserGuides: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
